import React, { PropTypes, Component } from 'react';
import AppContainer from '../containers/AppContainer.jsx';

class App extends Component {

  render() {
    return (
      <AppContainer>
        {this.props.children}
      </AppContainer>
    );
  }
}

App.propTypes = {
  children: PropTypes.element,
  route: PropTypes.object
};

export default App;



/** WEBPACK FOOTER **
 ** ./client/components/App.js
 **/